
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.297 12.625L14.703 24.203a.99.99 0 01-1.406 0L1.703 12.625a1.009 1.009 0 010-1.422l2.594-2.578a.99.99 0 011.406 0L14 16.922l8.297-8.297a.99.99 0 011.406 0l2.594 2.578a1.009 1.009 0 010 1.422z"}})])
          )
        }
      }
    